// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.Dashboards.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';

import connect from 'share/enhancers/Izenda.Connect';
import Panel from 'share/components/controls/Izenda.Panel';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import RightPanelContent from './Izenda.RightPanelContent';
import Header from './Izenda.Header';
import constants from 'logic/data/Izenda.PermissionConstants';

@connect()
export default class Dashboards extends Component {
  render() {
    const { model, localization } = this.props;

    const header = {
      component: Header,
      headerName: localization.getText('COMMON_LABEL_DASHBOARDS'),
      model
    };
    const mediumClassName = 'grid-medium-column u_borderRight u-bgWhite';

    return (
      <Panel
        className='u_fullHeight u_noMarginAll u_noBorder'
        header={header}
        collapsible
        expanedOption={model.collapseAll}
      >
        <GridLayout>
          <GridLayout.Row className='u_noMarginAll u_borderTop'>
            <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
              <GridLayout.Col cols='3' className='grid-small-column u_borderRight u-bgWhite'>
                <div>
                  <span className='u_smallIcon u_alignMiddle'>&#9899;</span>
                  <span>{localization.getText('PERMISSION_LABEL_CAN_CREATE_DASHBOARD')}</span>
                </div>
              </GridLayout.Col>
              <RightPanelContent model={model} keysPath='dashboards.canCreateNewDashboard.value' />
            </GridLayout.Col>
          </GridLayout.Row>

          <GridLayout.Row className='u_noMarginAll u_borderTop'>
            <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
              <GridLayout.Col cols='3' className='grid-small-column u_borderRight u-bgWhite'>
                <div>
                  <span className='u_smallIcon u_alignMiddle'>&#9899;</span>
                  <span>{localization.getText('PERMISSION_LABEL_DISPLAY_TILE_HEADER_IN_UNEDITABLE_DASHBOARD')}</span>
                </div>
              </GridLayout.Col>
              <RightPanelContent model={model} keysPath='dashboards.displayDashboardTileHeader.value' />
            </GridLayout.Col>
          </GridLayout.Row>

          <GridLayout.Row className='u_noMarginAll u_borderTop'>
            <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
              <GridLayout.Col cols='3' className='grid-small-column u_borderRight u-bgWhite'>
                <div>
                  <span className='u_smallIcon u_alignMiddle'>&#9899;</span>
                  <span>
                    {localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_DASHBOARD_CATEGORIES_SUBCATEGORIES')}
                  </span>
                </div>
              </GridLayout.Col>
              <RightPanelContent model={model} isParent />
            </GridLayout.Col>
          </GridLayout.Row>

          <GridLayout.Row className='u_noMarginAll u_borderTop'>
            <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
              <GridLayout.Col cols='3' className='grid-small-column u_borderRight u-bgWhite'>
                <span className='izenda-Permission-FirstChild'>
                  {localization.getText('PERMISSION_LABEL_CAN_CREATE_DASHBOARD')}
                </span>
              </GridLayout.Col>
              <RightPanelContent
                model={model}
                keysPath='dashboards.dashboardCategoriesSubcategories.canCreateNewCategory.value'
              />
            </GridLayout.Col>
          </GridLayout.Row>

          <GridLayout.Row className='u_noMarginAll u_borderTop'>
            <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
              <GridLayout.Col cols='3' className='grid-small-column u_borderRight u-bgWhite'>
                <span className='izenda-Permission-FirstChild'>
                  {localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_ACCESSIBILITY')}
                </span>
              </GridLayout.Col>
              <RightPanelContent model={model} isParent />
            </GridLayout.Col>
          </GridLayout.Row>

          <GridLayout.Row className='u_noMarginAll u_borderTop'>
            <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue izenda-Permission-LargeRow'>
              <GridLayout.Col cols='3' className={mediumClassName}>
                <span className='izenda-Permission-SecondChild'>
                  {localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_VISIBLE_CATEGORIES')}
                </span>
              </GridLayout.Col>
              <RightPanelContent
                notShowBlankCharacter={true}
                model={model}
                isParent
                showRole
                visibleCategories
                treeType={constants.TREE_TYPE.CATEGORY}
                popupTitle={localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_VISIBLE_DASHBOARD_CATEGORIES')}
                popupMessage={localization.getText(
                  'ROLE_SETUP_PERMISSION_SUMMARY_ROLE_CATEGORY_SUBCATEGORY_DASHBOARD_VIEW'
                )}
                keysPath='dashboards.dashboardCategoriesSubcategories.categoryAccessibility.categories'
              />
            </GridLayout.Col>
          </GridLayout.Row>

          <GridLayout.Row className='u_noMarginAll u_borderTop'>
            <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue izenda-Permission-LargeRow'>
              <GridLayout.Col cols='3' className={mediumClassName}>
                <span className='izenda-Permission-SecondChild'>
                  {localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_CATEGORIES_ALLOWED_FOR_SAVING_DASHBOARD')}
                </span>
              </GridLayout.Col>
              <RightPanelContent
                notShowBlankCharacter={true}
                model={model}
                isParent
                savableCategories
                showRole
                popupTitle={localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_SAVING_DASHBOARD_CATEGORIES')}
                popupMessage={localization.getText(
                  'ROLE_SETUP_PERMISSION_SUMMARY_ROLE_CATEGORY_SUBCATEGORY_DASHBOARD_SAVE'
                )}
                treeType={constants.TREE_TYPE.CATEGORY}
                keysPath='dashboards.dashboardCategoriesSubcategories.categoryAccessibility.categories'
              />
            </GridLayout.Col>
          </GridLayout.Row>

          <GridLayout.Row className='u_noMarginAll u_borderTop'>
            <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
              <GridLayout.Col cols='3' className='grid-small-column u_borderRight u-bgWhite'>
                <div>
                  <span className='u_smallIcon u_alignMiddle'>&#9899;</span>
                  <span>{localization.getText('COMMON_LABEL_ACTIONS')}</span>
                </div>
              </GridLayout.Col>
              <RightPanelContent model={model} isParent />
            </GridLayout.Col>
          </GridLayout.Row>

          <GridLayout.Row className='u_noMarginAll u_borderTop'>
            <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
              <GridLayout.Col cols='3' className='grid-small-column u_borderRight u-bgWhite'>
                <span className='izenda-Permission-FirstChild'>{localization.getText('COMMON_LABEL_SCHEDULE')}</span>
              </GridLayout.Col>
              <RightPanelContent model={model} keysPath='dashboards.actions.schedule' />
            </GridLayout.Col>
          </GridLayout.Row>

          <GridLayout.Row className='u_noMarginAll u_borderTop'>
            <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
              <GridLayout.Col cols='3' className='grid-small-column u_borderRight u-bgWhite'>
                <span className='izenda-Permission-FirstChild'>{localization.getText('COMMON_LABEL_SUBSCRIBE')}</span>
              </GridLayout.Col>
              <RightPanelContent model={model} keysPath='dashboards.actions.subscribe' />
            </GridLayout.Col>
          </GridLayout.Row>

          <GridLayout.Row className='u_noMarginAll u_borderTop'>
            <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
              <GridLayout.Col cols='3' className='grid-small-column u_borderRight u-bgWhite'>
                <span className='izenda-Permission-FirstChild'>
                  {localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_CONFIGURE_ACCESS')}
                </span>
              </GridLayout.Col>
              <RightPanelContent model={model} keysPath='dashboards.actions.configureAccessRights' />
            </GridLayout.Col>
          </GridLayout.Row>

          <GridLayout.Row className='u_noMarginAll u_borderTop'>
            <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
              <GridLayout.Col cols='3' className='grid-small-column u_borderRight u-bgWhite'>
                <span className='izenda-Permission-FirstChild'>{localization.getText('COMMON_LABEL_EMAIL')}</span>
              </GridLayout.Col>
              <RightPanelContent model={model} keysPath='dashboards.actions.email' />
            </GridLayout.Col>
          </GridLayout.Row>

          <GridLayout.Row className='u_noMarginAll u_borderTop'>
            <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
              <GridLayout.Col cols='3' className='grid-small-column u_borderRight u-bgWhite'>
                <span className='izenda-Permission-FirstChild'>{localization.getText('COMMON_LABEL_EXPORT')}</span>
              </GridLayout.Col>
              <RightPanelContent model={model} keysPath='dashboards.actions.exporting' />
            </GridLayout.Col>
          </GridLayout.Row>

          <GridLayout.Row className='u_noMarginAll u_borderTop'>
            <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
              <GridLayout.Col cols='3' className='grid-small-column u_borderRight u-bgWhite'>
                <span className='izenda-Permission-FirstChild'>{localization.getText('COMMON_LABEL_PRINT')}</span>
              </GridLayout.Col>
              <RightPanelContent model={model} keysPath='dashboards.actions.print' />
            </GridLayout.Col>
          </GridLayout.Row>

          <GridLayout.Row className='u_noMarginAll u_borderTop'>
            <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
              <GridLayout.Col cols='3' className='grid-small-column u_borderRight u-bgWhite'>
                <span className='izenda-Permission-FirstChild'>{localization.getText('COMMON_LABEL_DELETE')}</span>
              </GridLayout.Col>
              <RightPanelContent model={model} keysPath='dashboards.actions.del' />
            </GridLayout.Col>
          </GridLayout.Row>

          <GridLayout.Row className='u_noMarginAll u_borderTop'>
            <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
              <GridLayout.Col cols='3' className='grid-small-column u_borderRight u-bgWhite'>
                <span className='izenda-Permission-FirstChild'>
                  {localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_OVERWRITE_EXISTING_DASHBOARD')}
                </span>
              </GridLayout.Col>
              <RightPanelContent model={model} keysPath='dashboards.actions.overwriteExistingDashboard' />
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout>
      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/RoleSetup/RoleDetail/PermissionSummary/Izenda.Dashboards.js